"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contains_1 = require("../utils/contains");
/**
 * Check if a given node is contained by the given region
 * @param region The region to check from
 * @param node The node or block element to check
 */
function isNodeInRegion(region, node) {
    return !!(region &&
        contains_1.default(region.rootNode, node) &&
        (!region.nodeBefore ||
            region.nodeBefore.compareDocumentPosition(node) == 4 /* Following */) &&
        (!region.nodeAfter ||
            region.nodeAfter.compareDocumentPosition(node) == 2 /* Preceding */));
}
exports.default = isNodeInRegion;
//# sourceMappingURL=isNodeInRegion.js.map